import { keyframes } from 'styled-components';

export const rotate = keyframes`
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(-180deg);
    }
`;

